module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onActionSelect
    },
    model: {
      value: (_vm.actionShow),
      callback: function($$v) {
        _vm.actionShow = $$v
      },
      expression: "actionShow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("模板下载\n    ")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "accept": ".xls,.xlsx",
      "after-read": _vm.readFile
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("导入模板\n      ")])], 1)], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('div', {
    staticClass: "circle-div"
  }, [_c('van-circle', {
    attrs: {
      "stroke-width": 60,
      "color": {
        '0%': '#ffad19',
        '100%': '#fec835',
      },
      "rate": _vm.progress,
      "speed": 100,
      "text": _vm.progress + '%'
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "10px"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("上传中\n      ")])], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "批量导入错误信息"
    },
    model: {
      value: (_vm.showError),
      callback: function($$v) {
        _vm.showError = $$v
      },
      expression: "showError"
    }
  }, [_c('van-cell-group', _vm._l((_vm.errorMsg), function(item) {
    return _c('van-cell', {
      attrs: {
        "title": item
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-944d1a74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormShare.vue
// module id = 2553
// module chunks = 0